/* eslint-disable jsdoc/require-returns */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable valid-jsdoc */
/* eslint-disable jsdoc/require-param */
import { Series } from '../series/chart-series';
import { TechnicalAnalysis } from './indicator-base';
/**
 * `BollingerBands` module is used to render bollinger band indicator.
 */
export class BollingerBands extends TechnicalAnalysis {
    /**
     * Initializes the series collection to represent bollinger band.
     */
    initSeriesCollection(indicator, chart) {
        indicator.targetSeries = [];
        const rangeArea = new Series(indicator, 'targetSeries', {}, true);
        rangeArea.type = 'RangeArea';
        if (indicator.bandColor !== 'transparent' && indicator.bandColor !== 'none') {
            this.setSeriesProperties(rangeArea, indicator, 'BollingerBand', indicator.bandColor, 0, chart);
        }
        const signalLine = new Series(indicator, 'targetSeries', {}, true);
        this.setSeriesProperties(signalLine, indicator, 'BollingerBand', indicator.fill, indicator.width, chart);
        const upperLine = new Series(indicator, 'targetSeries', {}, true);
        this.setSeriesProperties(upperLine, indicator, 'UpperLine', indicator.upperLine.color, indicator.upperLine.width, chart);
        const lowerLine = new Series(indicator, 'targetSeries', {}, true);
        this.setSeriesProperties(lowerLine, indicator, 'LowerLine', indicator.lowerLine.color, indicator.lowerLine.width, chart);
    }
    /**
     * Defines the predictions using Bollinger Band Approach
     *
     * @private
     */
    initDataSource(indicator, chart) {
        const enableBand = indicator.bandColor !== 'transparent' && indicator.bandColor !== 'none';
        const start = enableBand ? 1 : 0;
        const signalCollection = [];
        const upperCollection = [];
        const lowerCollection = [];
        const bandCollection = [];
        const upperSeries = indicator.targetSeries[start + 1];
        const lowerSeries = indicator.targetSeries[start + 2];
        const signalSeries = indicator.targetSeries[start];
        const rangeAreaSeries = enableBand ? indicator.targetSeries[0] : null;
        //prepare data
        const validData = indicator.points;
        if (validData.length && validData.length >= indicator.period) {
            let sum = 0;
            let deviationSum = 0;
            const multiplier = indicator.standardDeviation;
            const limit = validData.length;
            const length = Math.round(indicator.period);
            const smaPoints = [];
            const deviations = [];
            const bollingerPoints = [];
            for (let i = 0; i < length; i++) {
                sum += Number(validData[i].close);
            }
            let sma = sum / indicator.period;
            for (let i = 0; i < limit; i++) {
                const y = Number(validData[i].close);
                if (i >= length - 1 && i < limit) {
                    if (i - indicator.period >= 0) {
                        const diff = y - Number(validData[i - length].close);
                        sum = sum + diff;
                        sma = sum / (indicator.period);
                        smaPoints[i] = sma;
                        deviations[i] = Math.pow(y - sma, 2);
                        deviationSum += deviations[i] - deviations[i - length];
                    }
                    else {
                        smaPoints[i] = sma;
                        deviations[i] = Math.pow(y - sma, 2);
                        deviationSum += deviations[i];
                    }
                    const range = Math.sqrt(deviationSum / (indicator.period));
                    const lowerBand = smaPoints[i] - (multiplier * range);
                    const upperBand = smaPoints[i] + (multiplier * range);
                    if (i + 1 === length) {
                        for (let j = 0; j < length - 1; j++) {
                            bollingerPoints[j] = {
                                'X': validData[j].x, 'mb': smaPoints[i],
                                'lb': lowerBand, 'ub': upperBand, visible: true
                            };
                        }
                    }
                    bollingerPoints[i] = {
                        'X': validData[i].x, 'mb': smaPoints[i],
                        'lb': lowerBand, 'ub': upperBand, visible: true
                    };
                }
                else {
                    if (i < indicator.period - 1) {
                        smaPoints[i] = sma;
                        deviations[i] = Math.pow(y - sma, 2);
                        deviationSum += deviations[i];
                    }
                }
            }
            let i = -1;
            let j = -1;
            for (let k = 0; k < limit; k++) {
                if (k >= (length - 1)) {
                    const ub = 'ub';
                    const lb = 'lb';
                    const mb = 'mb';
                    upperCollection.push(this.getDataPoint(validData[k].x, bollingerPoints[k][ub], validData[k], upperSeries, upperCollection.length));
                    lowerCollection.push(this.getDataPoint(validData[k].x, bollingerPoints[k][lb], validData[k], lowerSeries, lowerCollection.length));
                    signalCollection.push(this.getDataPoint(validData[k].x, bollingerPoints[k][mb], validData[k], signalSeries, signalCollection.length));
                    if (enableBand) {
                        bandCollection.push(this.getRangePoint(validData[k].x, upperCollection[++i].y, lowerCollection[++j].y, validData[k], rangeAreaSeries, bandCollection.length));
                    }
                }
            }
        }
        if (enableBand) {
            this.setSeriesRange(bandCollection, indicator, indicator.targetSeries[0]);
        }
        this.setSeriesRange(signalCollection, indicator, indicator.targetSeries[start]);
        this.setSeriesRange(upperCollection, indicator, indicator.targetSeries[start + 1]);
        this.setSeriesRange(lowerCollection, indicator, indicator.targetSeries[start + 2]);
    }
    /**
     * To destroy the Bollinger Band.
     *
     * @returns {void}
     * @private
     */
    destroy() {
        /**
         * Destroys the bollinger band
         */
    }
    /**
     * Get module name.
     */
    getModuleName() {
        /**
         * Returns the module name of the series
         */
        return 'BollingerBandsIndicator';
    }
}
